module.exports = __webpack_public_path__ + "static/media/svg-4.5871a517.svg";